import React from "react";

export const FileIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.25 2.5C2.83579 2.5 2.5 2.83579 2.5 3.25V15.25C2.5 15.6642 2.83579 16 3.25 16H13.75C14.1642 16 14.5 15.6642 14.5 15.25V7.75H11.5C10.2574 7.75 9.25 6.74264 9.25 5.5V2.5H3.25ZM10.75 3.56066L13.4393 6.25H11.5C11.0858 6.25 10.75 5.91421 10.75 5.5V3.56066ZM1 3.25C1 2.00736 2.00736 1 3.25 1H10C10.1989 1 10.3897 1.07902 10.5303 1.21967L15.7803 6.46967C15.921 6.61032 16 6.80109 16 7V15.25C16 16.4926 14.9926 17.5 13.75 17.5H3.25C2.00736 17.5 1 16.4926 1 15.25V3.25Z"
    />
  </svg>
);
